import { getClient } from "foundation-client";

export async function addFreeDraftToMyBooks(artId: number) {
  const client = getClient();
  await client.POST("/api/users/me/arts/{art_id}/free_draft", {
    params: { path: { art_id: artId } },
  });
}
